export default "__VITE_ASSET__BpS5J6Z3__"